export const TOPIC_TYPES = {
  ONBOARDING: 'ONBOARDING',
  OWNER_EMAIL: 'OWNER_EMAIL',
  FEEDBACK: 'FEEDBACK',
  OTHER: 'OTHER',
};

export const TOPICS = [
  {
    key: '1',
    label: 'Other',
    type: TOPIC_TYPES.OTHER,
  },
  {
    key: '2',
    label: "I'm not getting the correct matches",
    type: TOPIC_TYPES.ONBOARDING,
  },
  {
    key: '3',
    label: "I'm having trouble joining an event",
    type: TOPIC_TYPES.ONBOARDING,
  },
  {
    key: '4',
    label: "I haven't seen my photos yet",
    type: TOPIC_TYPES.OWNER_EMAIL,
  },
  {
    key: '5',
    label: "The photo quality that I'm receiving is poor",
    type: TOPIC_TYPES.OWNER_EMAIL,
  },
  {
    key: '6',
    label: 'Discuss Payment',
    type: TOPIC_TYPES.OWNER_EMAIL,
  },
  {
    key: '7',
    label: "I'd like to provide feedback about the app",
    type: TOPIC_TYPES.FEEDBACK,
  },
];
